/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ClassModuleDetailViewModel } from "../types/ClassModuleDetailViewModel.ts";
import { classModuleClassStudentViewModelSchema } from "./classModuleClassStudentViewModelSchema.ts";
import { classModuleDisciplineDetailViewModelSchema } from "./classModuleDisciplineDetailViewModelSchema.ts";
import { eCourseModalitySchema } from "./eCourseModalitySchema.ts";

export const classModuleDetailViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  description: z.string().nullish(),
  dateStart: z.string().datetime().nullish(),
  dateFinish: z.string().datetime().nullish(),
  companyId: z.number().int().nullish(),
  modality: z.optional(
    z
      .lazy(() => eCourseModalitySchema)
      .describe(
        "1 = Distance | 2 = Presential | 3 = SemiClassroom | 4 = OnDemand | ",
      ),
  ),
  classStudents: z
    .array(z.lazy(() => classModuleClassStudentViewModelSchema))
    .nullish(),
  disciplines: z
    .array(z.lazy(() => classModuleDisciplineDetailViewModelSchema))
    .nullish(),
}) as unknown as ToZod<ClassModuleDetailViewModel>;
